"use strict";

define('rs/models/abstract',['vertebrae', 'rs/helper', 'jquery', 'underscore', 'rs/errors', 'rs/paginate', 'evisions/promise'], function (Vertebrae, helper, $, _, RSError, Paginate, Promise) {
  var AbstractModel = Vertebrae.Model.extend({
    updateWithServerProperties: function updateWithServerProperties(data) {
      if (this.serverProperties) {
        data = _.pick(data, this.serverProperties);
      }
      this.applyProperties(data);
      return this;
    },
    toJSON: function toJSON() {
      if (this.serverProperties && this.serverProperties.length) {
        return this._super.apply(this, arguments);
      }
      return this.getProperties();
    }
  }, {
    timeout: 300000,
    crud: false,
    defaultHandler: function defaultHandler(data) {
      if (this.crud) {
        if (_.isArray(data)) {
          return this.models(data);
        } else if (_.isObject(data)) {
          return this.model(data);
        } else {
          return data;
        }
      }
      return data;
    },
    request: function request() {
      return Vertebrae.Model.request.apply(this, arguments);
    },
    ajax: function ajax(options) {
      var xhr = null,
        paginate = null;
      options.beforeSend = function (jXHR, opts) {
        xhr = jXHR;
      };
      if (options.data instanceof Paginate) {
        paginate = options.data;
        options.data = paginate.params();
      }
      return Promise.resolve(Backbone.ajax(options)).cancellable().caught(Promise.CancellationError, RSError.NavigationCancelled, function (e) {
        xhr.abort();
      }).tap(function (resp) {
        if (paginate && resp.page) {
          paginate.setPage(resp.page.page);
          paginate.setTotalPages(resp.page.totalPages);
          paginate.setTotalItems(resp.page.total);
          if (_.isArray(resp.data)) {
            paginate.setTotalPageItems(resp.data.length);
          }
        }
      }).caught(function (e) {
        throw new RSError.HTTPError({
          valid: false,
          error: {
            code: 'http-' + e.status,
            message: e.responseText,
            detail: {}
          }
        });
      });
    },
    reject: function reject(resp) {
      return Promise.reject(resp);
    },
    resolve: function resolve(data, params, resp) {
      return Promise.resolve(data);
    },
    isValidResponse: function isValidResponse(resp) {
      return resp.valid;
    },
    getResponseDefaults: function getResponseDefaults() {
      return {
        valid: false
      };
    },
    getResponseSuccessPayload: function getResponseSuccessPayload(resp) {
      return resp.data;
    },
    getResponseFailPayload: function getResponseFailPayload(resp) {
      if (resp && resp.validation) {
        return new RSError.ValidationError(resp);
      }
      return new RSError.APIError(resp);
    }
  });
  return AbstractModel;
});

